import React from 'react';
import { Spin } from 'antd';
import moment from 'moment';
import useMeterReading from '../../queries/useMeterReading';
import SendMeters from '../SendMeters/SendMeters';
import MetersHistory from '../MetersHistory/MetersHistory';
import styles from './MetersExpandedRow.module.scss';

const MetersExpandedRow = ({ meter }) => {
  const { data: meterReading, isFetching } = useMeterReading(meter.id, {
    staleTime: Infinity,
  });

  return (
    <Spin spinning={isFetching}>
      <div className={styles.metersExpandedRowLayout}>
        <div className={styles.flexSmall}>
          <div className={styles.flex}>
            <div className={styles.intelItem}>
              <div className={styles.name}>Дата ввода в эксплуатацию</div>
              <div>
                {meter.commissioningDate
                  ? moment(meter.commissioningDate).format('DD.MM.YYYY')
                  : 'нет данных'}
              </div>
            </div>
            <div className={styles.intelItem}>
              <div className={styles.name}>Дата поверки</div>
              <div>
                {meter.verificationDate
                  ? moment(meter.verificationDate).format('DD.MM.YYYY')
                  : 'нет данных'}
              </div>
            </div>
          </div>
          <div className={styles.intelItem}>
            <div className={styles.name}>Комментарий</div>
            <div>{meter.description || '-'}</div>
          </div>
        </div>
        <div className={styles.flexSmall}>
          <SendMeters meter={meter} meterReading={meterReading} />
        </div>
        <div className={styles.flexHalf}>
          <MetersHistory meterReading={meterReading} />
        </div>
      </div>
    </Spin>
  );
};

export default MetersExpandedRow;
